import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

import App from "./pages/App";
import AnalysisPage from "./pages/AnalysisPage";
import DashboardPage from "./pages/DashboardPage";
import Iex from "./pages/iex";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";

export default function MainApp() {
  const [dsmData, setDsmData] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("dsmData");

    if (saved) {
      setDsmData(JSON.parse(saved));
    }
  }, []);

  return (
    <Router>
      <Routes>

        {/* Login Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Home Page */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <App
                dsmData={dsmData}
                setDsmData={setDsmData}
              />
            </ProtectedRoute>
          }
        />

        {/* Analysis Page */}
        <Route
          path="/analysis"
          element={
            <ProtectedRoute>
              <AnalysisPage dsmData={dsmData} />
            </ProtectedRoute>
          }
        />

        {/* Dashboard */}
        <Route
          path="/DashboardPage"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* IEX Page */}
        <Route
          path="/iex"
          element={
            <ProtectedRoute>
              <Iex />
            </ProtectedRoute>
          }
        />

        {/* Redirect Unknown Routes */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </Router>
  );
}
